import React from 'react';
import moment from 'moment';
import { ReactComponent as Video } from '../../../../../../../../common/images/videoPlayer.svg';
import { ReactComponent as Comment } from '../../../../../../../../common/images/commentText.svg';
import { ReactComponent as Microphone } from '../../../../../../../../common/images/microphone.svg';
import { ReactComponent as Download } from '../../../../../../../../common/images/download.svg';
import { BtnTable } from '../../../../../../../../common/ui/Common';

export default function TableConfig(filteredData, handleClick) {
  return (
    [
      {
        title: 'Id',
        dataIndex: 'id',
        key: 'id',
        width: 100,
        fixed: 'left',
        defaultSortOrder: 'descend',
        sorter: (a, b) => a.id - b.id,
      },
      {
        title: 'Дата прохождения',
        dataIndex: 'created_on',
        key: 'created_on',
        width: 160,
        fixed: 'left',
        sorter: (a, b) => {
          const aToSec = new Date(moment(a.created_on, 'DD.MM.YYYY HH:mm:ss')).getTime();
          const bToSec = new Date(moment(b.created_on, 'DD.MM.YYYY  HH:mm:ss')).getTime();
          return (aToSec - bToSec);
        },
      },
      {
        title: 'Источник',
        dataIndex: 'source',
        width: 200,
        filters: filteredData.sourceList,
        onFilter: (value, record) => (record.source.indexOf(value) === 0),
      },

      // {
      //   title: 'Фотография',
      //   dataIndex: 'photo_b64',
      //   width: 170,
      //   render: (_, row) => {
      //     const { photo_b64: photoB64 } = row;
      //     const regEx = /data:image\/([a-zA-Z]*);base64,([^"]*)/g;
      //     if (photoB64 && regEx.test(photoB64)) {
      //       return (
      //         <img src={photoB64} data-name="photo" style={{ cursor: 'pointer', height: 50 }} alt="customer" />
      //       );
      //     }
      //     return 'Нет фотографии';
      //   },
      // },
      {
        title: 'Содержимое',
        key: 'record',
        render: (_, res) => {
          const renderContent = () => {
            if (res.audiorecordpath !== '') {
              return (
                <div style={{ marginLeft: '5px' }}>
                  <BtnTable onClick={() => handleClick('micro', res)} data-name="micro" type="button"><Microphone /></BtnTable>
                </div>
              );
            }

            if (res.videorecordpath !== '') {
              return (
                <div style={{ marginLeft: '5px' }}>
                  <BtnTable onClick={() => handleClick('video', res)} data-name="video" type="button"><Video /></BtnTable>
                </div>
              );
            }

            if (res.extraData) {
              return (
                <div style={{ marginLeft: '5px' }}>
                  <BtnTable onClick={() => handleClick('comment', res)} data-name="comment" type="button"><Comment /></BtnTable>
                </div>
              );
            }

            return <span>Нет записи</span>;
          };

          return (
            <div style={{ display: 'flex' }}>
              {renderContent()}
            </div>
          );
        },
      },
      {
        title: 'Файлы',
        dataIndex: 'files',
        render: (_, res) => {
          if (res.files.length > 0) {
            return (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {res.files.map((el) => (
                  <a href={el.downloadLink} target="_blank" rel="noopener noreferrer">
                    <BtnTable data-name="download" type="button" style={{ display: 'flex', width: 'auto' }}>
                      {el.fileName}
                      {' '}
                      <Download style={{ maxWidth: '20px', marginLeft: '10px' }} />
                    </BtnTable>
                  </a>
                ))}
              </div>
            );
          }
          return (
            <div style={{ display: 'flex' }}>
              <span>Файлов нет</span>
            </div>
          );
        },
      },

    ]
  );
}
